import {Flow} from 'flow-to-typescript-codemod';

import * as React from 'react';

import classify from 'src/utils/classify';

import css from './hover-button.css';


type ButtonProps = {
  className: string;
  onClick?: (arg1: React.SyntheticEvent) => unknown;
  style?:
    | {
        [key: string]: string | number;
      }
    | null
    | undefined;
};

export type HoverButtonProps = {
  [key: string]: any;
  ElementType?: React.ComponentType<ButtonProps> | string;
  children: React.ReactNode;
  onClick?: (arg1: React.SyntheticEvent) => unknown;
  bgIconClassName?: string;
  backgroundColor?: string;
  className?: string;
  justify?: 'start' | 'center' | 'end';
  isClickable?: unknown;
  hoverDisabled?: boolean;
  active?: boolean;
  disabled?: boolean;
};

export const HoverButton = (
  props: HoverButtonProps &
    Omit<
      Omit<
        // @ts-expect-error TS2304
        Flow.ComponentProps<typeof ElementType>,
        'type' | 'role' | 'className' | 'onClick'
      >,
      keyof HoverButtonProps
    >,
  // @ts-expect-error - TS2344 - Type 'string' does not satisfy the constraint 'JSXElementConstructor<any> | keyof IntrinsicElements'.
): React.ReactNode | React.ReactElement<React.ComponentProps<string>> => {
  const {
    ElementType = 'button',
    children,
    onClick,
    className,
    bgIconClassName,
    backgroundColor,
    rootClassName,
    justify = 'center',
    isClickable = true,
    hoverDisabled = false,
    active = false,
    disabled = false,
    ...rest
  } = props;

  return (
    // @ts-expect-error - TS2769 - No overload matches this call.
    <ElementType
      {...rest}
      type="button"
      role="button"
      className={classify(css.hoverBtn, rootClassName)}
      onClick={(evt) => {
        if (!disabled) {
          onClick?.(evt);
        }
      }}
    >
      <div
        className={classify(
          css.hoverContainer,
          css[justify],
          isClickable && !disabled && css.isClickable,
        )}
      >
        <div className={classify(css.hoverContent, className)}>{children}</div>
        <div
          className={classify(bgIconClassName, {
            [css.hoverBg]: !hoverDisabled,
            [css.hoverBgActive]: active,
          })}
          // @ts-expect-error - TS2322 - Type '"" | { backgroundColor: string; } | undefined' is not assignable to type 'CSSProperties | undefined'.
          style={backgroundColor && {backgroundColor}}
        />
      </div>
    </ElementType>
  );
};
